export default `
  mutation removeAiProviderKey($provider: AiProvider!) {
    removeAiProviderKey(provider: $provider) {
      status
    }
  }
`
